import React, { Component } from "react";
import { TenancyRequest } from "@eres/ejari-api/Entity/tenant";
import { I8N, LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import ListDataView from "@my-dld/components/DataView/ListDataView";
import Strings from "@my-dld/assets/strings";
import {
	getTenantReqAmount,
	getTenantReqBuildingName,
	getTenantReqContractNo,
	getTenantReqEndDate,
	getTenantReqStartDate,
	getTenantReqStatus,
	getTenantReqUnitNo
} from "../../screens/Tenant/Requests/MyTenantRequests";
import { IDtoEnum } from "@eres/ejari-api/Utils";
import { EjariPropertyType } from "@eres/ejari-api/Entity";

export interface TenantReqProps {
	items: TenancyRequest[];
	onDetails: ( request: TenancyRequest ) => void;
}

class TenantRequestsListView extends Component<TenantReqProps> {
	componentDidMount(): void {
		this.configDataTable();
	}

	render() {
		const { items } = this.props;
		return <ListDataView
			items={ items }
			renderListHeader={ () => {
				return <RenderHeader/>;
			} }
			renderListItem={ ( item: TenancyRequest, index: number ) => {
				return <RenderListItem
					key={ `${ index }_${ item.ContractNumber }` }
					item={ item }/>;
			} }/>;
	}

	private configDataTable = () => {
		try {
			window.$( "#ListView" ).DataTable( {
				//language: LocaleUtil.Select( DataTableLang ),
                language: { url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/" + (I8N.current == "ar" ? "Arabic.json" : "English.json"), lengthMenu: '_MENU_' },
                dom: "<'table-responsive'rt>" + "<'dt-cfooter'i<'dt-fpl'pl>>",
                pagingType: "simple_numbers",
				responsive: false,
				lengthChange: false,
				scrollX: true,
			} );
			const onDetails = this.props.onDetails;
			window.$( "#ListView" ).on( "click", "tr", function () {
				// @ts-ignore
				let item = JSON.parse( this.getAttribute( "data-item" ) );
				if ( item )
					onDetails( item );
				return false;
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};
}

function RenderHeader() {
	return <tr>
		{/*<th>{ Strings.property_type }</th>*/ }
		<th>{ Strings.building_name }</th>
		<th>{ Strings.Unit_Number_Label }</th>
		<th>{ Strings.start_date }</th>
		<th>{ Strings.end_date }</th>
		<th>{ Strings.contract_number }</th>
		<th>{ Strings.contract_status }</th>
		<th>{ Strings.contract_amount_aed }</th>
		<th>{ "" }</th>
	</tr>;
}

function RenderListItem( props: { item: TenancyRequest } ) {
	const { item } = props;
	const propertyType = IDtoEnum<EjariPropertyType>( EjariPropertyType, item.PropertyTypeID )!;
	return <tr data-item={ JSON.stringify( item ) } className="clickable-row">
		{/*<td data-label={Strings.property_type}>{ getTenantReqPropertyTypeName(propertyType) }</td>*/ }
		<td data-label={ Strings.building_name }>{ getTenantReqBuildingName( item ) }</td>
		<td data-label={ Strings.Unit_Number_Label }>{ getTenantReqUnitNo( item, propertyType ) }</td>
		<td data-label={ Strings.start_date }>{ getTenantReqStartDate( item ) }</td>
		<td data-label={ Strings.end_date }>{ getTenantReqEndDate( item ) }</td>
		<td data-label={ Strings.contract_number }>{ getTenantReqContractNo( item ) }</td>
		<td data-label={ Strings.contract_status }>{ getTenantReqStatus( item ) }</td>
		<td data-label={ Strings.contract_amount_aed }>{ getTenantReqAmount( item ) }</td>
		<td className="text-center">
			<span className="table-view-detail-link"> { Strings.view_details } </span>
			<i className="fas fa-arrow-alt-circle-right"/>

		</td>
	</tr>;
}

export default TenantRequestsListView;
